import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import useFavorites from '../../../hooks/useFavorites';

import { useMenus } from '../../../contexts/SiteContext';
import Film from '../../cards/Film';
import Loader from '../../partials/Loader';
import PageMeta from '../../partials/PageMeta';
import Sidebar from '../../partials/Sidebar';

import styles from '../../../../styles/pages/pro.module.css';

const propTypes = { page: PropTypes.shape({ id: PropTypes.string }) };

function Favorites({ page = null }) {
    const { pro } = useMenus();
    const { title = null } = page || {};
    const { data: favorites = null, isLoading = false } = useFavorites();
    return (
        <div className={styles.container}>
            <PageMeta page={page} />
            <Sidebar className={styles.sidebar} menu={pro} title={title}>
                {favorites !== null && favorites.length > 0 ? (
                    <div className={styles.grid}>
                        {favorites.map((favorite) => (
                            <Film
                                key={`favorite-${favorite?.id}`}
                                className={styles.item}
                                item={favorite?.film}
                                withFavorite
                            />
                        ))}
                    </div>
                ) : null}
                {(favorites === null || favorites.length === 0) && !isLoading ? (
                    <p>
                        <FormattedMessage
                            defaultMessage="No favorites yet! Go to a film and click on the heart icon to add it here."
                            description="Help text"
                        />
                    </p>
                ) : null}
                {isLoading ? <Loader /> : null}
            </Sidebar>
        </div>
    );
}

Favorites.propTypes = propTypes;

export default Favorites;
